import React from 'react'
import history from '../../../context/history'
import { userKeys } from '../../../queries/user/keyFactory'
import { useQueryClient } from '@tanstack/react-query'
import { IUserData } from '../../../queries/user/types'
import { useUserContext } from '../../../context/user/UserProvider'
import { useProductContext } from '../../../context/products/ProductProvider'
import ProLineNavSectionMobile from './ProLineNavSectionMobile'
import ProLineOffCanvasShopProductsMobile from '../../organisms/Header/ProLineOffCanvasShopProductsMobile'
import {
  useProlineInformationOptionsData,
  useProlinePricingOptionsData,
} from '../../../queries/site'

interface ISideNavMenuMobileProps {
  handleClick?: () => void | null
}

const ProLineSideNavMenuItemsMobile: React.FC<ISideNavMenuMobileProps> = ({
  handleClick,
}) => {
  const { isDarkMode } = useUserContext()
  const { setPage } = useProductContext()
  const queryClient = useQueryClient()
  const user = queryClient.getQueryData(userKeys.user) as IUserData

  const { data: information } = useProlineInformationOptionsData()
  const { data: pricing } = useProlinePricingOptionsData()

  const onClickQuickLink = (e: any) => {
    setPage(1)
    history.push(e.target.id)
    handleClick?.()
  }

  const sections = [
    {
      title: 'Shop Products',
      component: (
        <ProLineOffCanvasShopProductsMobile handleClose={handleClick} />
      ),
      useQueryParams: false,
    },
    {
      title: 'Information',
      data: information,
      useQueryParams: false,
    },
    {
      title: 'Pricing',
      data: pricing,
      useQueryParams: false,
    },
  ]

  return (
    <div className="border-top">
      {sections.map((section) => (
        <ProLineNavSectionMobile
          key={section.title}
          title={section.title}
          data={section.data}
          component={section.component}
          isDarkMode={isDarkMode}
          onClickQuickLink={onClickQuickLink}
          useQueryParams={section.useQueryParams}
        />
      ))}
    </div>
  )
}

export default ProLineSideNavMenuItemsMobile
